import React, { useState, useEffect, useRef } from 'react';
import { generatePin } from '../utils/pinGenerator';
import './Login.css';

export default function Login({ onLogin }) {
  // Tymczasowa flaga - ustaw na false aby wyłączyć przycisk bez PIN
  const TEMPORARY_LOGIN_WITHOUT_PIN_ENABLED = true;
  
  const [employeeNumber, setEmployeeNumber] = useState('');
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [correctPin, setCorrectPin] = useState('');
  const employeeInputRef = useRef(null);
  const pinInputRef = useRef(null);

  useEffect(() => {
    // Wczytaj zapisany login z localStorage
    const savedEmployeeNumber = localStorage.getItem('employeeNumber');
    if (savedEmployeeNumber) {
      setEmployeeNumber(savedEmployeeNumber);
      pinInputRef.current?.focus();
    } else {
      employeeInputRef.current?.focus();
    }
  }, []);

  const handleEmployeeNumberChange = (e) => {
    const value = e.target.value;
    setEmployeeNumber(value);
    if (value) {
      localStorage.setItem('employeeNumber', value);
    } else {
      localStorage.removeItem('employeeNumber');
    }
  };

  const handleKeyPress = (e, field) => {
    if (e.key === 'Enter') {
      if (field === 'employee' && employeeNumber) {
        pinInputRef.current?.focus();
      } else if (field === 'pin') {
        handleLogin();
      }
    }
  };

  const handleLogin = async () => {
    const number = parseInt(employeeNumber);
    if (isNaN(number) || number < 1 || number > 100000) {
      setError('Numer pracownika musi być z zakresu 1-100000');
      employeeInputRef.current?.focus();
      return;
    }

    const generatedPin = await generatePin(employeeNumber);
    if (pin === generatedPin) {
      onLogin(employeeNumber);
    } else {
      setError('Niepoprawny PIN');
      // setCorrectPin(`Poprawny PIN to: ${generatedPin}`);
      pinInputRef.current?.focus();
    }
  };

  const handleLoginWithoutPin = () => {
    setError('');
    // Używamy specjalnej wartości oznaczającej logowanie bez PIN
    onLogin('TEMP_NO_PIN');
  };

  return (
    <div className="login-container">
      <h2>Logowanie</h2>
      <div className="form-group">
        <input
          ref={employeeInputRef}
          type="number"
          placeholder="Numer pracownika (1-100000)"
          value={employeeNumber}
          onChange={handleEmployeeNumberChange}
          onKeyPress={(e) => handleKeyPress(e, 'employee')}
          min="1"
          max="100000"
        />
      </div>
      <div className="form-group">
        <input
          ref={pinInputRef}
          type="password"
          placeholder="PIN"
          value={pin}
          onChange={(e) => setPin(e.target.value)}
          onKeyPress={(e) => handleKeyPress(e, 'pin')}
        />
      </div>
      {error && <div className="error-message">{error}</div>}
      {correctPin && <div className="correct-pin">{correctPin}</div>}
      <button onClick={handleLogin}>Zaloguj się</button>
      
      {TEMPORARY_LOGIN_WITHOUT_PIN_ENABLED && (
        <div className="temporary-login">
          <button 
            onClick={handleLoginWithoutPin}
            className="btn-temp-login"
            style={{ 
              marginTop: '10px', 
              backgroundColor: '#f39c12', 
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Logowanie bez PIN (tymczasowe)*
          </button>
          <p style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
            * Opcja dostępna do czasu udostępnienia PIN-ów wszystkim pracownikom
          </p>
        </div>
      )}
    </div>
  );
} 